export const setUser = (user: any) => ({
  type: "SET_USER",
  payload: user,
});